<template>
  <div class="radio-group">
    <label v-if="label" class="radio-group-label">{{ label }}{{ required ? '*' : '' }}</label>
    <div class="radio-options">
      <label 
        v-for="option in options" 
        :key="option.value" 
        class="radio-option"
      >
        <input 
          type="radio" 
          :name="name" 
          :value="option.value"
          :checked="modelValue === option.value"
          @change="$emit('update:modelValue', option.value)"
        >
        <span class="radio-circle"></span>
        {{ option.text }}
      </label>
    </div>
    <div v-if="error" class="error-message">{{ error }}</div>
  </div>
</template>

<script>
export default {
  name: 'RadioGroup',
  props: {
    modelValue: {
      type: [String, Number, Boolean],
      default: null
    },
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue']
}
</script>

<style scoped>
.radio-group {
  margin-bottom: 20px;
}

.radio-group-label {
  display: block;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 10px;
  color: #333;
}

.radio-options {
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
}

.radio-option {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.radio-option input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.radio-circle {
  position: relative;
  height: 20px;
  width: 20px;
  background-color: #f0f0f0;
  border-radius: 50%;
  margin-right: 10px;
  display: inline-block;
  border: 1px solid #ddd;
}

.radio-option input:checked ~ .radio-circle {
  background-color: white;
  border: 2px solid #e94057;
}

.radio-option input:checked ~ .radio-circle:after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #e94057;
}

.error-message {
  color: #e94057;
  font-size: 14px;
  margin-top: 5px;
}
</style> 